export default "__VITE_PUBLIC_ASSET__b0219658__"